import { useGetDemoQuery } from '@carboncopyco/data';
import { type IGlobalTab, TabGroupName } from '@carboncopyco/types/desktop';
import { useEffect, useState } from 'react';
import { useTabs } from '../../store/context';

interface Props {
  tab: IGlobalTab;
  organizationId: string;
  demoId: string;
}

const useIsDemoPlayReady = ({ tab, organizationId, demoId }: Props) => {
  const [isReady, setIsReady] = useState(false);
  const { setGlobalTabs, globalTabsRef } = useTabs();

  const isPlaybook =
    tab.group?.name === TabGroupName.PlaybookPreview ||
    tab.group?.name === TabGroupName.PlaybookPresentation;

  const { data: demo } = useGetDemoQuery(
    {
      workspaceId: tab.workspaceId || '',
      organizationId,
      id: demoId,
    },
    {
      skip: !isPlaybook,
    }
  );

  useEffect(() => {
    if (!isPlaybook) {
      setIsReady(true);
    }
  }, []);

  /**
   * It's important to skip useGetDemoQuery and to not update tabs for tabs that are not playbook because it will override variables and rules
   */
  useEffect(() => {
    if (demo) {
      const toUpdate = globalTabsRef.current.map((oldTab) => {
        const isTabToUpdate = oldTab.id === tab.id;

        return isTabToUpdate
          ? {
              ...oldTab,
              url: decodeURIComponent(demo.firstUrl),
              innerTabs: [
                {
                  ...tab.innerTabs[0],
                  url: decodeURIComponent(demo.firstUrl),
                },
              ],
              payload: {
                ...tab.payload,
                demo,
              },
            }
          : oldTab;
      });

      setGlobalTabs(toUpdate);
      setIsReady(true);
    }
  }, [demo]);

  return { isReady };
};

export default useIsDemoPlayReady;
